import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import ExportDownloadMenuItem from './ExportDownloadMenuItem';
import { fetchAssessmentQcExport } from '../../services/assessments';
import { slugifyFilenamePart } from '../../utils/filenameUtils';

const AssessmentActionsCell = ({ assessmentSurveyId, fallbackName }: {
  assessmentSurveyId: number;
  fallbackName?: string;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton size="small" onClick={handleMenuOpen}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <ExportDownloadMenuItem
          label="Download QC Export"
          fallbackBasename={`assessment-qc-${slugifyFilenamePart(fallbackName) || assessmentSurveyId}`}
          fetchExport={(includeEvidence) => fetchAssessmentQcExport(assessmentSurveyId, includeEvidence)}
          onComplete={handleMenuClose}
        />
      </Menu>
    </>
  );
};

export default AssessmentActionsCell;
